import CrudRequest from '@/app/arch/components/crud/CrudRequest';
import httpService from '@/app/arch/services/HttpService';

class ProdutoTemplateRequest extends CrudRequest {
  static baseUrl() {
    return '/produto-servico/template-produto';
  }

  static list(params = { }) {
    return httpService.get(`${this.baseUrl()}/list-all/details`, {
      params,
    });
  }

  static listSimple(params = { }) {
    return httpService.get(`${this.baseUrl()}/list-all`, {
      params,
    });
  }

  static save(payload) {
    return httpService.post(`${this.baseUrl()}/add`, payload);
  }

  static listAgrupamentoByClient(clientId) {
    return httpService.get(
      `${this.baseUrl()}/list-agrupamento-by-cliente/${clientId}`,
    );
  }

  static listAgrupamentoByLoja(lojaId) {
    return httpService.get(
      `/produto-servico/template-produto-loja/group-by-store/${lojaId}`,
    );
  }
}

export default ProdutoTemplateRequest;
